import { render, staticRenderFns } from "./BaseFileInput.vue?vue&type=template&id=41a9472b&scoped=true"
import script from "./BaseFileInput.vue?vue&type=script&lang=js"
export * from "./BaseFileInput.vue?vue&type=script&lang=js"
import style0 from "./BaseFileInput.vue?vue&type=style&index=0&id=41a9472b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a9472b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
